import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@ot/shared/utils';
import { BaidPickerComponent } from '@ot/shared/baid-picker';
import { LegalNoticeComponent } from '@ot/shared/legal-notice';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'fuel'
  },
  {
    path: 'fuel',
    loadChildren: '@ot/ifta/features/fuel#FuelModule',
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  },
  {
    path: 'legal',
    component: LegalNoticeComponent
  },
  {
    path: 'distance',
    loadChildren: '@ot/ifta/features/distance#DistanceModule',
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  },
  {
    path: 'filings',
    loadChildren: '@ot/ifta/features/filing#FilingModule',
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  },
  {
    path: 'baid-picker',
    component: BaidPickerComponent
  },
  {
    path: 'app-admin',
    loadChildren: '@ot/ifta/features/vehicle-extension#VehicleExtensionModule',
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  },
  {
    path: 'error',
    loadChildren: '@ot/shared/features/error-handler#ErrorHandlerModule'
  },
  { path: '**', redirectTo: '/error?type=404&message=Page is not found' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
